import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorkReportLinksApi extends ApiModule {
    constructor() {
        super(ModulesMap.WORK_REPORT_LINKS, {
            entity: 'work_report_links',
        })
    }
}
